import { useCalibration } from '../../context/calibrationContext';
import { ScreenTooSmall, useScreenSizeCheck } from '../../ui';

// Shows the "Tiny Screen Alert!" (SPEC 4.7) over the patient's screen when it is below the 280 mm
// minimum (policy in ui/ScreenTooSmall.js). Children stay mounted underneath so the call and the
// socket keep running while the patient goes full screen / rotates the device.
export const ScreenSizeGuard = ({ enabled = true, children }) => {
  const calibration = useCalibration();
  const { pixelDensity, screenCalibrated } = calibration?.calibrationData || {};
  const { tooSmall } = useScreenSizeCheck({ enabled, pixelDensity, calibrated: Boolean(screenCalibrated) });
  return (
    <>
      {children}
      {tooSmall && <ScreenTooSmall overlay />}
    </>
  );
};

export default ScreenSizeGuard;
